module.exports = __webpack_public_path__ + "img/chart.0b064977.png";